import React from 'react';
import { ShareBottomSheetConsumer } from './ShareBottomSheetConsumer';

export const withShareBottomSheet = Component => props => (
  <ShareBottomSheetConsumer>
    <Component {...props} />
  </ShareBottomSheetConsumer>
);
